<div
	class="modal fade"
	id="filtersModal"
	tabindex="-1"
	role="dialog"
	aria-labelledby="filtersModalLabel"
	aria-hidden="true"
>
	<div class="modal-dialog modal-dialog-scrollable">
		<div class="modal-content">
			<div class="modal-body">
				<div class="container">
					<div class="form-floating col mb-3">
						<input
							type="text"
							class="form-control"
							name="search"
							[(ngModel)]="filters.search"
							id="search"
						/>
						<label for="search" class="form-label">Nazwa wydarzenia</label>
					</div>
					<mat-radio-group
						class="d-flex flex-row gap-2 mt-3 mb-3"
						[(ngModel)]="filters.selectedFilterCustomerKind"
					>
						<mat-radio-button (change)="changeSelectedData(true)" [value]="customerType.PRIVATE"
							>Klient indywidualny
						</mat-radio-button>
						<mat-radio-button (change)="changeSelectedData(false)" [value]="customerType.COMPANY"
							>Firma
						</mat-radio-button>
					</mat-radio-group>
					<ng-container *ngIf="filters.selectedFilterCustomerKind === customerType.PRIVATE">
						<ng-select
							id="client"
							name="client"
							[(ngModel)]="filters.client"
							[multiple]="true"
							[closeOnSelect]="false"
						>
							<ng-option *ngFor="let item of profile" [value]="item.id"
								>{{ item.firstName }} {{ item.lastName }} | {{ item.birth }} |
								{{ item.userContacts[0]?.phone }}
							</ng-option>
						</ng-select>
					</ng-container>
					<ng-container *ngIf="filters.selectedFilterCustomerKind === customerType.COMPANY">
						<ng-select
							id="company"
							name="company"
							[items]="organization"
							bindValue="id"
							bindLabel="shortName"
							[(ngModel)]="filters.company"
							[multiple]="true"
							[closeOnSelect]="false"
						>
						</ng-select>
					</ng-container>
					<div class="mb-3">
						<div class="row g-2">
							<div class="form-floating col-md">
								<input
									type="date"
									class="form-control"
									name="date_from"
									[(ngModel)]="filters.date_from"
									id="date_from"
								/>
								<label for="date_from" class="form-label">Data wydarzenia od</label>
							</div>
							<div class="form-floating col-md">
								<input
									type="date"
									class="form-control"
									name="date_to"
									[(ngModel)]="filters.date_to"
									id="date_to"
								/>
								<label for="date_to" class="form-label">Data wydarzenia do</label>
							</div>
						</div>
					</div>
					<div class="mb-3">
						<div class="row g-2">
							<div class="form-floating col-md">
								<input
									type="date"
									class="form-control"
									name="due_from"
									[(ngModel)]="filters.due_from"
									id="due_from"
								/>
								<label for="due_from" class="form-label">Termin płatności od</label>
							</div>
							<div class="form-floating col-md">
								<input
									type="date"
									class="form-control"
									name="due_to"
									[(ngModel)]="filters.due_to"
									id="due_to"
								/>
								<label for="due_to" class="form-label">Termin płatności do</label>
							</div>
						</div>
					</div>
					<div class="mb-3">
						<label for="owners" class="mt-3">Opiekun</label>
						<ng-select
							id="owners"
							name="owners"
							[(ngModel)]="filters.owners"
							[multiple]="true"
							[closeOnSelect]="false"
						>
							<ng-option *ngFor="let item of owners" [value]="item.id">{{ item.name }}</ng-option>
						</ng-select>
					</div>
					<div class="mb-3">
						<label for="documentTypes" class="mt-3">Typ dokumentu</label>
						<ng-select
							id="documentTypes"
							name="documentTypes"
							[(ngModel)]="filters.documentTypes"
							[multiple]="true"
							[closeOnSelect]="false"
						>
							<ng-option *ngFor="let item of documentTypes" [value]="item.id">{{ item.name }}</ng-option>
						</ng-select>
					</div>
					<div class="mb-3">
						<label for="statusNames" class="mt-3">Status</label>
						<ng-select
							id="statusNames"
							name="statusNames"
							[(ngModel)]="filters.statusNames"
							[multiple]="true"
							[closeOnSelect]="false"
						>
							<ng-option *ngFor="let item of statusNames" [value]="item.id">{{ item.name }}</ng-option>
						</ng-select>
					</div>
					<div class="mb-3">
						<div class="form-floating">
							<input
								type="date"
								class="form-control"
								name="documentDate"
								[(ngModel)]="filters.date"
								id="documentDate"
							/>
							<label for="documentDate" class="form-label">Data dokumentu</label>
						</div>
					</div>
					<div class="form-floating mt-3">
						<select class="form-select" id="settled" name="settled" [(ngModel)]="filters.settled">
							<option value="">(wszystkie)</option>
							<option [value]="item.id" *ngFor="let item of yesno">
								{{ item.name }}
							</option>
						</select>
						<label for="settled">Zapłacone</label>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<div class="container">
					<div class="row">
						<div class="col-sm-7 text-start">
							<button type="button" class="btn btn-danger me-1" (click)="filtersClear()">Wyczyść</button>
							<button type="button" class="btn btn-success" (click)="filtersDefault()">Domyślne</button>
						</div>
						<div class="col-sm-5 text-end">
							<button type="button" class="btn btn-primary me-1" (click)="filtersSave()">Pokaż</button>
							<button
								type="button"
								class="btn btn-secondary"
								(click)="filtersClose()"
								data-bs-dismiss="modal"
							>
								Anuluj
							</button>
						</div>
					</div>
					<div class="row mt-2">
						<div class="col-sm-12 text-start"></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
